import React from 'react';
import { SVGIconProps } from '../../domains/common';

const FacebookIcon: React.FC<SVGIconProps> = ({ colored, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 740 510"
      {...rest}
    >
      <path
        d="M527.1 51.2c-25 2.5-54 17-79 39.3-13.9 12.4-35.7 36.9-49.6 55.7l-2 2.7-9.5-11.6c-12.1-14.9-38-41-49-49.5-23.4-18-42.9-27.9-67-33.9-8.6-2.1-11.7-2.4-32-2.4-20.4 0-23.4.2-32 2.4C158.8 66 117.2 101.8 84.7 159 61 200.8 45.4 249.8 38.6 303.5c-9 70.9.2 127.7 26.8 165.3 6.8 9.6 20.8 23.3 30.3 29.5 18.6 12.3 41.9 18.7 67.5 18.7 64 0 104.5-37.5 175.9-162.5 8.5-14.9 22.7-39.7 31.4-55.2 8.8-15.6 16.3-28.3 16.7-28.3.4 0 14 22.4 30.4 49.7 36.1 60.5 45.8 76.4 58.7 95.8 50 75.2 85.6 100.5 140.8 100.5 32.5 0 58.1-10.1 78.9-31 20.5-20.6 33.7-50.3 39.4-88.6 7.2-47.7 1.8-111.8-13.9-165.4-11.9-40.7-29.5-76.8-52-106.8-9-12.1-26.6-30.6-37-39.2-26.4-21.6-55.3-33.5-84.5-34.9-7.5-.3-16.9-.3-20.9.1zm16.6 59.8c52.9 5.6 98.8 66.2 118.7 157 6.2 28.1 8.9 53.6 9 85.5.1 27.2-.6 33.6-5.4 49.5-6.8 22.2-19.1 34.3-38.3 37.6-12.5 2.2-24.5.1-35.4-6.3-6.7-3.8-20.5-17.9-29.5-29.8-16.6-22.1-41.8-61.5-78.9-123.1-13.6-22.7-29.8-49.1-36-58.8-6.3-9.7-12.7-19.7-14.2-22.1l-2.8-4.4 5.2-7.8c32.7-49 60.6-73.1 89.4-77.2 8.3-1.2 7.9-1.2 18.2-.1zM257 129.1c26.8 6.8 52.6 29.2 86 74.7l8.3 11.3-3 4.7c-1.7 2.6-13.3 20.7-26 40.2-12.6 19.5-30.5 47.4-39.8 62-52 81.6-74.6 108.5-98 116.5-6.3 2.1-18 3.7-22.4 3-14.4-2.4-22.1-5.9-29.9-13.8-9.5-9.7-15.9-23.9-19.3-42.7-1.8-9.5-1.8-49.2 0-64.5 11.5-101.4 59-182.9 112.6-193.1 8.5-1.6 21.1-.9 31.5 1.7z"
        fill={colored ? '#3c5a9a' : 'currentColor'}
      />
    </svg>
  );
};

export default FacebookIcon;
